import React from 'react';
import PropTypes from 'prop-types';
import { 
  makeStyles,
  Paper,
} from '@material-ui/core';
import { Create as CreateIcon } from '@material-ui/icons';
import clsx from 'clsx';

import placeholder from 'img/profile-placeholder.png';

const useUserStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'left',
    marginBottom: '10px',
    padding: '10px',
    cursor: 'pointer',
  },
  active: {
    backgroundColor: theme.custom.secondary,
  },
  avatar: {
    height: '45px',
    width: '45px',
    borderRadius: '45px',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  info: {
    paddingLeft: '10px',
    flex: '1',
    '& p, & h4': {
      margin: '0',
    },
  },
}));

const User = ({ name, role, selected }) => {
  const classes = useUserStyles();

  return (
    <Paper className={clsx({
      [classes.wrapper]: true,
      [classes.active]: selected,
    })}>
      <Paper className={classes.avatar}>
        <img src={placeholder} alt="" />
      </Paper>
      <div className={classes.info}>
        <h4>{name}</h4>
        <p>{role}</p>
      </div>
      {selected && <CreateIcon />}
    </Paper>
  );
};

User.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
};

export default User;
